import { render, staticRenderFns } from "./satisfactionSetting.vue?vue&type=template&id=613b17d9&scoped=true&"
import script from "./satisfactionSetting.vue?vue&type=script&lang=ts&"
export * from "./satisfactionSetting.vue?vue&type=script&lang=ts&"
import style0 from "./satisfactionSetting.vue?vue&type=style&index=0&id=613b17d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b17d9",
  null
  
)

export default component.exports